import { isNumber } from 'lodash'

/**
 * Format passed number into a readable usd format
 */
export const usd = (amount = 0, maximumFractionDigits = 1) => {
  if (!isNumber(amount)) return ''
  const fraction = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'usd',
    minimumFractionDigits: 0,
    maximumFractionDigits,
  })

  return fraction.format(amount)
}
